const CTASection = () => {
  return (
    <section className="w-full">
      <div className="flex flex-col lg:flex-row">
        <div className="w-full lg:w-1/2 relative h-[400px] md:h-[500px] overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=Artistic%20overhead%20composition%20of%20carefully%20arranged%20fashion%20and%20lifestyle%20shopping%20items%20on%20warm%20textured%20paper%2C%20including%20folded%20cashmere%20sweater%20cinnamon%20stick%20candle%20and%20leather%20bound%20notebook%2C%20soft%20golden%20hour%20light%20raking%20across%20surface%2C%20rich%20caramel%20and%20cream%20color%20scheme%2C%20editorial%20catalog%20aesthetic%2C%20autumn%20cozy%20atmosphere%2C%20no%20text%20visible%2C%20premium%20lifestyle%20product%20photography&width=1200&height=900&seq=cta-v2-shopping-scene&orientation=landscape"
            alt="Ready to start shopping with Hipobuy Spreadsheet"
            title="Explore Hipobuy Spreadsheet Products"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent"></div>
          <div className="absolute bottom-10 left-10">
            <p className="text-white/70 text-sm font-medium mb-2">Start Exploring</p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
              Ready To
              <br />
              Start Shopping?
            </h2>
          </div>
        </div>

        <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center py-16 px-10 md:px-16">
          <div className="max-w-md text-center">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight mb-6">
              Visit Kaspreadsheet
              <br />
              For Best Deals
            </h2>
            <p className="text-foreground-500 text-base leading-relaxed mb-8">
              All Hipobuy Spreadsheet categories link directly to Kaspreadsheet — your trusted source for verified product listings, competitive pricing, and seamless shopping experience.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white text-base font-semibold hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap"
            >
              Visit Kaspreadsheet Now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;